<template>
    <vx-box color="info" class="flex flex-col items-center justify-center gap-8 py-16 mt-10 md:mt-0">
        <motion.div
            :initial="checkmarkVariants.hidden"
            :animate="checkmarkVariants.visible"
            :transition="checkmarkTransition"
        >
            <vx-badge size="md" color="violet">
                <font-awesome-icon :icon="faSparkles"></font-awesome-icon>
                Intelligent Inbox
            </vx-badge>
        </motion.div>

        <motion.div initial="hidden" animate="visible" :transition="successTextStagger" class="text-center space-y-2">
            <motion.h2
                :variants="fadeUpVariants"
                :transition="mediumTransition"
                class="text-3xl font-bold text-slate-800"
            >
                You're All Set!
            </motion.h2>
            <motion.p :variants="fadeUpVariants" :transition="mediumTransition" class="text-slate-500 text-lg max-w-md">
                Your intelligent inbox is configured and ready to go.
            </motion.p>
        </motion.div>

        <motion.div
            :initial="fadeUpVariants.hidden"
            :animate="fadeUpVariants.visible"
            :transition="successActionTransition"
        >
            <vx-button color="primary" size="xl" fancy @click="goToInbox()">
                Go to Inbox
                <font-awesome-icon :icon="faArrowRight"></font-awesome-icon>
            </vx-button>
        </motion.div>
    </vx-box>
</template>

<script lang="ts" setup>
import { VxBox, VxButton, VxBadge } from '@voxie/frontend-components';
import { faArrowRight, faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { motion } from 'motion-v';
import { useRouter } from 'vue-router';
import { useIntelligentInbox } from '../useIntelligentInbox';
import {
    fadeUpVariants,
    checkmarkVariants,
    checkmarkTransition,
    mediumTransition,
    successTextStagger,
    successActionTransition,
} from './wizardMotionVariants';

const router = useRouter();
const { markSetupComplete } = useIntelligentInbox();

const goToInbox = (): void => {
    markSetupComplete();
    router.push({ name: 'message-hub.intelligent-inbox' });
};
</script>
